/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-explicit-any */
import HB_ from '@honeybadger-io/js'
import SupportedBrowsersRegexp from 'browsers'
const noop = (..._args: any[]): any => {}
type Badger = typeof HB_

const HBStub = {
  beforeNotify: noop,
  configure: noop,
  errorHandler: noop,
  requestHandler: noop,
  lambdaHandler: noop,
  config: {} as any,
  afterNotify: noop,
  setContext: noop,
  clear: noop,
  notify: (...args) => {
    console.log('Honeybadger JS is stubbed in this env, skipping notice:', ...args)
  },
} as Badger

const IgnoredUserAgents = [
  'BingPreview',
  'Chrome[ /]([123]\\d|4[^1])\\.', // ancient chrome versions, except Googlebot (v41)
  'CriOS[ /][1234]\\d\\.', // ancient chrome-on-iOS versions
  'DuckDuckGo',
  'Firefox/[1234]\\d?\\.',
  'FxiOS/\\d\\.', // ancient Firefox for iOS (v < 10)
  'GSA',
  'hellotalk',
  'wkhtmltopdf',
  '(iPhone|iPad|CPU).*OS ([56789]|10)[._].*(Safari|like Mac OS)', // old mobile safari
  'MAGIX BROWSER',
  'Media Center PC', // windows media center browser (old IE)
  'MicroMessenger', // WeChat
  'MIUI',
  'Mozilla/5.*Android [1-4]\\..*AppleWebKit', // old stock android browser
  'MQQBrowser',
  'MSIE',
  'Opera Coast',
  'Opera Mini',
  'OPR[ /][1-5]\\d\\.', // old Operas (pre 2019)
  'Qt/',
  'QuantBrowser',
  'SamsungBrowser.[1-7]\\.', // old Samsung Internet browser (pre 2019)
  'Version/(\\d|10|11)\\.[\\d.]* Safari', // old Safaris (v < 12, pre 2018)
  'Yandex',
  'UCBrowser',
  'Vivaldi',
  'WorxWeb',
  'Instagram',
]

const IgnoredUserAgentsRegexp = new RegExp(IgnoredUserAgents.join('|'), 'i')

const IgnoredMessages = [
  '__firefox__', // internal error in Firefox for iOS
  'BetterJsPop',
  'Failed to execute.*Node', // caused by google translate et al.
  'IE Intranet mode',
  'Illegal invocation',
  'Invalid site key or not loaded in api',
  'Netzwerkverbindung.*unterbrochen',
  'No response from window',
  'No value passed to payment',
  'Please load Stripe',
  'URIError.*recaptcha|recaptcha.*is not accessible',
  'Stripe.js requires that your page has a <body>',
  'Window closed',
  'Window not found on which to reject sendMessage',
  'Zeitüberschreitung',
  'Zugriff verweigert',
  'avast',
  'cannot redefine.*googletag',
  'closingEls',
  'could not retrieve data from the specified Element',
  'kaspersky',
  'network error', // TODO: remove. see client.js.
  'non-configurable property .*userAgent',
  'pktAnnotationHighlighter',
  'postMessage zoid_init',
  'postrobot',
  'tgetT is not defined',
  'translate.googleusercontent.com',
  'webkitExitFullScreen',
  'xoplatform/logger',
  'ztePageScrollModule',
  'TypeError.*null is not an object.*evaluating', // Minified 3rd code
  'Detected container element removed from DOM',
]

const IgnoredMessagesRegexp = new RegExp(IgnoredMessages.join('|'), 'i')

const IgnoredStackRegexp = /(chrome|moz|safari)-extension|recaptcha/i

if (window.HoneybadgerConfig) {
  const { apiKey, environment, revision } = window.HoneybadgerConfig
  HB_.configure({
    apiKey,
    environment,
    revision,
  })
  HB_.beforeNotify((notice) => {
    if (!notice) return false
    if (!SupportedBrowsersRegexp.test(navigator?.userAgent)) return false
    if (IgnoredUserAgentsRegexp.test(navigator?.userAgent)) return false
    if (IgnoredStackRegexp.test(notice.stack)) return false
    if (IgnoredStackRegexp.test(notice.backtrace?.join(''))) return false
    if (IgnoredMessagesRegexp.test(notice.message)) return false
  })
}
const HB = (window.HoneybadgerConfig && HB_) || HBStub
window.Honeybadger = HB
